module.exports = __webpack_public_path__ + "static/feature_colorado_sun2-2228039b478d356f3405b913155f53f3.jpg";